// extracted by mini-css-extract-plugin
export default {"container":"CreateCollection_container__9b3hV","subContainer":"CreateCollection_subContainer__5dqJl","leftArrow":"CreateCollection_leftArrow__PPvkY"};